// removed by extract-text-webpack-plugin
module.exports = {"main":"sIXbSqijhDwHOKkMsb58D"};


//////////////////
// WEBPACK FOOTER
// ./components/ReceiptFooter.module.css
// module id = 2365
// module chunks = 1